module.exports = __webpack_public_path__ + "static/media/cover_page_new01.9f18d685.gif";